import { getHostApi } from '@/utils';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import { createToken } from '@/utils/request';

export const getGloAIProductList = async (params: any, locale: string) => {
    const API_HOST = getHostApi(locale as string).NEXT_PUBLIC_API_HOST;
    const headers = getDefaultHeader(locale as string);
    let globalData: any = {};

    // 检查用户是否登录，如果登录则添加token到headers
    const token = createToken();
    const requestHeaders: any = {
        ...headers,
        'Content-Type': 'application/json',
    };

    if (!!token) {
        requestHeaders.Authorization = `Bearer ${token}`;
    }

    try {
        const productData = await fetch(`${API_HOST}/aiSearch`, {
            method: 'POST',
            headers: requestHeaders,
            body: JSON.stringify(params),
        });
        globalData = await productData.json();
    } catch (error) {
        console.log({ traceId: headers.traceId, error });
    }

    return globalData || {};
};
